// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/logo-dark.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-dark {
  --color-navy-blue: #34495e;
  --color-navy-blue-fade-5: rgba(52, 73, 94, 0.05);
  --color-navy-blue-darken-5: #2b3c4e;
  --color-navy-blue-darken-10: #222f3d;
  --color-navy-blue-lighten-5: #3d566e;
  --color-navy-blue-lighten-15: #4f6f8f;
  --color-navy-blue-lighten-20: #587ca0;
  --color-navy-blue-lighten-25: #6789ab;
  --color-navy-blue-lighten-50: #b9c8d8;
  --color-violet: #D8B1FF;
  --color-violet-fade-5: rgba(216, 177, 255, 0.05);
  --color-violet-darken-5: #cb98ff;
  --color-violet-darken-10: #be7eff;
  --color-violet-lighten-5: #e5cbff;
  --color-violet-lighten-15: #fefeff;
  --color-violet-lighten-20: #ffffff;
  --color-violet-lighten-25: #ffffff;
  --color-violet-lighten-50: #ffffff;
  --color-blue: #b9c8d8;
  --color-blue-fade-5: rgba(185, 200, 216, 0.05);
  --color-blue-darken-5: #a9bbcf;
  --color-blue-darken-10: #98aec6;
  --color-blue-lighten-5: #c9d5e1;
  --color-blue-lighten-15: #eaeff3;
  --color-blue-lighten-20: #fbfbfc;
  --color-blue-lighten-25: #ffffff;
  --color-blue-lighten-50: #ffffff;
  --color-green: #8BE2A3;
  --color-green-fade-5: rgba(139, 226, 163, 0.05);
  --color-green-darken-5: #77dd93;
  --color-green-darken-10: #62d883;
  --color-green-lighten-5: #9fe7b3;
  --color-green-lighten-15: #c8f1d4;
  --color-green-lighten-20: #ddf6e4;
  --color-green-lighten-25: #f1fbf4;
  --color-green-lighten-50: #ffffff;
  --color-yellow: #F1D77A;
  --color-yellow-fade-5: rgba(241, 215, 122, 0.05);
  --color-yellow-darken-5: #efd063;
  --color-yellow-darken-10: #ecc94c;
  --color-yellow-lighten-5: #f3de91;
  --color-yellow-lighten-15: #f8ecbf;
  --color-yellow-lighten-20: #fbf3d6;
  --color-yellow-lighten-25: #fdfaed;
  --color-yellow-lighten-50: #ffffff;
  --color-orange: #FFC38B;
  --color-orange-fade-5: rgba(255, 195, 139, 0.05);
  --color-orange-darken-5: #ffb671;
  --color-orange-darken-10: #ffa958;
  --color-orange-lighten-5: #ffd0a4;
  --color-orange-lighten-15: #ffebd8;
  --color-orange-lighten-20: #fff8f1;
  --color-orange-lighten-25: #ffffff;
  --color-orange-lighten-50: #ffffff;
  --color-red: #FF98A2;
  --color-red-fade-5: rgba(255, 152, 162, 0.05);
  --color-red-darken-5: #ff7f8b;
  --color-red-darken-10: #ff6574;
  --color-red-lighten-5: #ffb2b9;
  --color-red-lighten-15: #ffe5e7;
  --color-red-lighten-20: #fffefe;
  --color-red-lighten-25: #ffffff;
  --color-red-lighten-50: #ffffff;
  --color-red-deep: #c0392b;
  --color-red-deep-fade-5: rgba(192, 57, 43, 0.05);
  --color-red-deep-darken-5: #ab3326;
  --color-red-deep-darken-10: #962d22;
  --color-red-deep-lighten-5: #d14233;
  --color-red-deep-lighten-15: #db695d;
  --color-red-deep-lighten-20: #df7c72;
  --color-red-deep-lighten-25: #e48f86;
  --color-red-deep-lighten-50: #fbf0ef;
}
.theme-dark .screen,
.theme-dark .header,
.theme-dark .footer,
.theme-dark .modal-content,
.theme-dark .btn-action-grid,
.theme-dark .legacy-styles {
  background: #2e3440;
  color: #eceff4;
  border-color: #4c566a;
}
.theme-dark .screen .waiting-overlay,
.theme-dark .header .waiting-overlay,
.theme-dark .footer .waiting-overlay,
.theme-dark .modal-content .waiting-overlay,
.theme-dark .btn-action-grid .waiting-overlay,
.theme-dark .legacy-styles .waiting-overlay {
  background: #2e3440;
}
.theme-dark .header ul,
.theme-dark .header li {
  background: #4c566a;
  color: #eceff4;
}
.theme-dark h1 small {
  color: #e5e9f0;
}
.theme-dark .modal-header,
.theme-dark .modal-footer {
  background: #4c566a;
  color: #eceff4;
  border-color: #4c566a;
}
.theme-dark .modal-header button.close,
.theme-dark .modal-footer button.close {
  color: #eceff4;
  opacity: 0.8;
}
.theme-dark .modal-header .btn-default,
.theme-dark .modal-footer .btn-default {
  border-color: #eceff4;
}
.theme-dark .border-bottom {
  border-color: #4c566a;
}
.theme-dark .modal-backdrop {
  opacity: 0.75;
}
.theme-dark .btn-action-grid-container .modal-backdrop {
  background: rgba(0, 0, 0, 0.75);
}
.theme-dark .btn-default {
  background: #4c566a;
  color: #eceff4;
  border-color: #4c566a;
}
.theme-dark .btn-default:active,
.theme-dark .btn-default:hover:active {
  color: #eceff4;
  border-color: #4c566a;
  background: #2e3440;
}
.theme-dark .btn-default.selected {
  border: 2px solid var(--color-green);
}
.theme-dark .btn-primary.btn-outline {
  color: #eceff4;
}
.theme-dark .btn-primary.btn-outline:active {
  background: rgba(255, 255, 255, 0.4);
}
.theme-dark .btn-info {
  background: var(--color-blue);
  border-color: var(--color-blue);
  color: #eceff4;
}
.theme-dark .btn-info.btn-outline {
  background: transparent;
  color: white;
}
.theme-dark .btn-info.btn-outline:active {
  background: rgba(255, 255, 255, 0.4);
}
.theme-dark .btn-value:active,
.theme-dark .btn-value:hover:active {
  border-color: var(--color-green);
}
.theme-dark .btn-value img[src] + span {
  background: rgba(0, 0, 0, 0.6);
}
.theme-dark .btn-value .btn-value-badge {
  background: #4c566a;
  border: 1px solid #4c566a;
  color: #eceff4;
}
.theme-dark .bg-value-button-grid-separator {
  background-color: #4c566a;
}
.theme-dark.theme-show-help .btn-action img + span,
.theme-dark.theme-show-help .btn-action svg + span {
  background: rgba(0, 0, 0, 0.6);
}
.theme-dark.theme-show-help .btn-action img + span span,
.theme-dark.theme-show-help .btn-action svg + span span {
  color: #eceff4;
}
.theme-dark .form-control::placeholder {
  color: #647ca5;
}
.theme-dark .form-control,
.theme-dark .form-control[readOnly]:not(.disable-keypad) {
  cursor: default;
  background-color: #2e3440;
  border-color: #4c566a !important;
  color: #eceff4;
}
.theme-dark .form-control[readOnly]:not(.disable-keypad).selected,
.theme-dark .form-control:focus {
  border: 1px solid var(--color-green) !important;
}
.theme-dark .input-group-addon {
  border-color: #4c566a !important;
  background-color: #2e3440;
  color: #eceff4;
}
.theme-dark .has-error .help-block {
  font-weight: 600;
  color: #BF616A;
}
.theme-dark ul.list li:nth-child(even) {
  background: #3e4552;
}
.theme-dark ul.list li.selected {
  background-color: var(--color-green-lighten-5) !important;
  color: #2e3440 !important;
}
.theme-dark ul.list li.selected .btn-info {
  border-color: #2e3440;
}
.theme-dark .table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #4c566a;
}
.theme-dark .select2-container .select2-selection,
.theme-dark .select2-container .select2-results,
.theme-dark .select2-container .select2-search--dropdown {
  background: #2e3440;
  border-color: #4c566a;
}
.theme-dark .select2-container .select2-selection span,
.theme-dark .select2-container .select2-results span,
.theme-dark .select2-container .select2-search--dropdown span {
  color: #eceff4;
}
.theme-dark .select2-container .select2-selection b,
.theme-dark .select2-container .select2-results b,
.theme-dark .select2-container .select2-search--dropdown b {
  border-color: #eceff4 transparent transparent transparent;
}
.theme-dark .select2-container .select2-selection li,
.theme-dark .select2-container .select2-results li,
.theme-dark .select2-container .select2-search--dropdown li {
  color: #e5e9f0;
}
.theme-dark .select2-container .select2-selection input,
.theme-dark .select2-container .select2-results input,
.theme-dark .select2-container .select2-search--dropdown input {
  cursor: default;
  background-color: #2e3440;
  border-color: #4c566a !important;
  color: #eceff4;
}
.theme-dark .select2-container .select2-dropdown {
  border-color: #4c566a;
}
.theme-dark .select2-container .select2-results__option[aria-selected=true] {
  background: #4c566a;
  color: #eceff4;
}
.theme-dark .abc-checkbox label::before {
  background-color: #2e3440;
  border-color: #4c566a;
}
.theme-dark .abc-checkbox label::after {
  color: #eceff4;
}
.theme-dark .react-datepicker {
  background: #2e3440;
  border-color: #4c566a;
}
.theme-dark .react-datepicker .react-datepicker__header,
.theme-dark .react-datepicker .react-datepicker__today-button {
  background: #4c566a;
  border-color: #4c566a;
  color: var(--color-blue);
}
.theme-dark .react-datepicker .react-datepicker__day-name,
.theme-dark .react-datepicker .react-datepicker__day,
.theme-dark .react-datepicker .react-datepicker__time-name,
.theme-dark .react-datepicker .react-datepicker__current-month,
.theme-dark .react-datepicker .react-datepicker-time__header,
.theme-dark .react-datepicker .react-datepicker-year-header {
  color: #eceff4;
}
.theme-dark .react-datepicker .react-datepicker__day--outside-month {
  color: #4c566a;
}
.theme-dark .react-datepicker .react-datepicker__day--outside-month:hover {
  color: #eceff4;
}
.theme-dark .react-datepicker .react-datepicker__day:hover,
.theme-dark .react-datepicker .react-datepicker__month-text:hover,
.theme-dark .react-datepicker .react-datepicker__quarter-text:hover,
.theme-dark .react-datepicker .react-datepicker__today-button:hover {
  background-color: #4c566a;
}
.theme-dark .alert-warning {
  color: #8a6d3b;
  background-color: #ebcb8b;
  border-color: #ebcb8b;
}
.theme-dark .text-muted {
  color: #a4b2cb !important;
}
.theme-dark .text-danger {
  color: #BF616A !important;
}
.theme-dark .text-info {
  color: white !important;
}
.theme-dark .text-info.fa-chevron-down,
.theme-dark .text-info.fa-chevron-up {
  color: white !important;
}
.theme-dark #toast-container > div {
  background: #4c566a !important;
  background-image: none !important;
}
.theme-dark #toast-container > div .btn-default {
  border-color: #eceff4;
}
.theme-dark #toast-container > div .toast-message {
  background: #4c566a;
  color: #eceff4;
}
.theme-dark .keypad-container-wrapper {
  background-color: #2e3440;
}
.theme-dark .keypad {
  background-color: #2e3440;
}
.theme-dark .keyboard-container {
  background-color: #2e3440;
  border-top: 1px solid #4c566a;
}
.theme-dark .ticket-lines-total {
  border-top: 1px solid #4c566a;
  background: #2e3440;
}
.theme-dark .panel-horizontal {
  background: #2e3440;
  border-top-color: #2e3440;
  border-right-color: #2e3440;
  border-bottom-color: #2e3440;
}
.theme-dark .panel-horizontal.info {
  border-left-color: var(--color-blue);
}
.theme-dark .panel-horizontal.info.selected {
  background-color: var(--color-blue-fade-5);
  border-color: var(--color-blue);
}
.theme-dark .panel-horizontal.success {
  border-left-color: var(--color-green);
}
.theme-dark .panel-horizontal.success.selected {
  background-color: var(--color-green-fade-5);
  border-color: var(--color-green);
}
.theme-dark .panel-horizontal.primary {
  border-left-color: var(--color-navy-blue);
}
.theme-dark .panel-horizontal.primary.selected {
  background-color: var(--color-navy-blue-fade-5);
  border-color: var(--color-navy-blue);
}
.theme-dark .panel-horizontal.primary2 {
  border-left-color: var(--color-violet);
}
.theme-dark .panel-horizontal.primary2.selected {
  background-color: var(--color-violet-fade-5);
  border-color: var(--color-violet);
}
.theme-dark .panel-horizontal.warning {
  border-left-color: var(--color-yellow);
}
.theme-dark .panel-horizontal.warning.selected {
  background-color: var(--color-yellow-fade-5);
  border-color: var(--color-yellow);
}
.theme-dark .panel-horizontal.warning2 {
  border-left-color: var(--color-orange);
}
.theme-dark .panel-horizontal.warning2.selected {
  background-color: var(--color-orange-fade-5);
  border-color: var(--color-orange);
}
.theme-dark .panel-horizontal.danger {
  border-left-color: var(--color-red-deep);
}
.theme-dark .panel-horizontal.danger.selected {
  background-color: var(--color-red-deep-fade-5);
  border-color: var(--color-red-deep);
}
.theme-dark .panel-horizontal.danger2 {
  border-left-color: var(--color-red);
}
.theme-dark .panel-horizontal.danger2.selected {
  background-color: var(--color-red-fade-5);
  border-color: var(--color-red);
}
.theme-dark .bg-light {
  background: #3e4552;
}
.theme-dark .border-top {
  border-top: 1px solid #4c566a;
}
.theme-dark .border-bottom {
  border-bottom: 1px solid #4c566a;
}
.theme-dark .border-right {
  border-right: 1px solid #4c566a;
}
.theme-dark .border-left {
  border-left: 1px solid #4c566a;
}
.theme-dark .card-grid .card {
  border-color: #4c566a;
}
.theme-dark .card-grid .card:hover {
  border-color: #616e88;
}
.theme-dark .card-grid .card.selected {
  border-color: var(--color-green);
}
.theme-dark .card-grid .card .card-title {
  color: #eceff4;
}
.theme-dark .card-grid .card .card-description {
  color: #e5e9f0;
}
.theme-dark ul.dropdown-menu {
  background-color: #4c566a;
}
.theme-dark ul.dropdown-menu li:hover,
.theme-dark ul.dropdown-menu li:active {
  background: #2e3440;
}
.theme-dark .public_fixedDataTable_main {
  background: #2e3440;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_header .public_fixedDataTableCell_main {
  background: #4c566a;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_header .public_fixedDataTableCell_cellContent {
  color: #eceff4 !important;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main {
  background: #2e3440;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main .public_fixedDataTableCell_main {
  background: #2e3440;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main.public_fixedDataTableRow_odd {
  background: #3e4552;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main.public_fixedDataTableRow_odd .public_fixedDataTableCell_main {
  background: #3e4552;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer {
  border-color: #4c566a;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer .public_fixedDataTableCell_main {
  background: #4c566a;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer .public_fixedDataTableCell_cellContent {
  color: #eceff4 !important;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTable_hasBottomBorder {
  border-color: #4c566a;
}
.theme-dark .public_fixedDataTable_main .public_fixedDataTableCell_main {
  border-right: 0px solid transparent;
}
.theme-dark .public_fixedDataTable_main .selected .public_fixedDataTableCell_main {
  background-color: var(--color-green-lighten-5) !important;
  color: #2e3440 !important;
}
.theme-dark .public_fixedDataTable_main .public_Scrollbar_main {
  background-color: #2e3440;
}
.theme-dark .public_fixedDataTable_main .public_Scrollbar_face:after {
  background-color: #4c566a;
}
.theme-dark .public_fixedDataTable_main > .tools-buttons .btn-outline.btn-info {
  background-color: #2e3440;
}
.theme-dark .numeric-datatable.public_fixedDataTable_main .public_fixedDataTable_bodyRow .public_fixedDataTableCell_cellContent {
  background: #4c566a;
}
.theme-dark .numeric-datatable.public_fixedDataTable_main .public_fixedDataTable_bodyRow .numeric .public_fixedDataTableCell_cellContent {
  background: #2e3440;
}
.theme-dark .bg-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.theme-dark .simple-keyboard {
  background-color: #2e3440;
  border-color: #4c566a;
}
.theme-dark .simple-keyboard .hg-button {
  background: #4c566a;
  color: #f7f9fa;
  border-color: #4c566a;
}
.theme-dark .simple-keyboard .hg-button:active {
  background: #2e3440;
  border-color: #4c566a;
}
.theme-dark .simple-keyboard .hg-button.hg-button-special {
  color: #f7f9fa;
  border-color: #4c566a;
  background-color: var(--color-navy-blue);
}
.theme-dark svg path[fill="#4C566A"] {
  fill: white;
}
.theme-dark svg path[stroke="#4C566A"] {
  stroke: white;
}
.theme-dark svg path[fill="#61AAED"] {
  fill: #A6D4FF;
}
.theme-dark svg path[stroke="#61AAED"] {
  stroke: #A6D4FF;
}
.theme-dark svg path[fill="#C291F3"] {
  fill: #D8B1FF;
}
.theme-dark svg path[stroke="#C291F3"] {
  stroke: #D8B1FF;
}
.theme-dark svg path[fill="#FFBA7B"] {
  fill: #FFC38B;
}
.theme-dark svg path[stroke="#FFBA7B"] {
  stroke: #FFC38B;
}
.theme-dark svg path[fill="#A2BAD0"] {
  fill: #ACC0D2;
}
.theme-dark svg path[stroke="#A2BAD0"] {
  stroke: #ACC0D2;
}
.theme-dark svg path[fill="#FF8A95"] {
  fill: #FF98A2;
}
.theme-dark svg path[stroke="#FF8A95"] {
  stroke: #FF98A2;
}
.theme-dark svg path[fill="#75CA8D"] {
  fill: #8BE2A3;
}
.theme-dark svg path[stroke="#75CA8D"] {
  stroke: #8BE2A3;
}
.theme-dark svg path[fill="#D6AF28"] {
  fill: #F1D77A;
}
.theme-dark svg path[stroke="#D6AF28"] {
  stroke: #F1D77A;
}
.theme-dark svg path[fill="white"] {
  fill: #4C566A;
}
.theme-dark svg path[stroke="white"] {
  stroke: #4C566A;
}
.theme-dark svg path[fill="#A6D4FF"] {
  fill: #61AAED;
}
.theme-dark svg path[stroke="#A6D4FF"] {
  stroke: #61AAED;
}
.theme-dark svg path[fill="#D8B1FF"] {
  fill: #C291F3;
}
.theme-dark svg path[stroke="#D8B1FF"] {
  stroke: #C291F3;
}
.theme-dark svg path[fill="#FFC38B"] {
  fill: #FFBA7B;
}
.theme-dark svg path[stroke="#FFC38B"] {
  stroke: #FFBA7B;
}
.theme-dark svg path[fill="#ACC0D2"] {
  fill: #A2BAD0;
}
.theme-dark svg path[stroke="#ACC0D2"] {
  stroke: #A2BAD0;
}
.theme-dark svg path[fill="#FF98A2"] {
  fill: #FF8A95;
}
.theme-dark svg path[stroke="#FF98A2"] {
  stroke: #FF8A95;
}
.theme-dark svg path[fill="#8BE2A3"] {
  fill: #75CA8D;
}
.theme-dark svg path[stroke="#8BE2A3"] {
  stroke: #75CA8D;
}
.theme-dark svg path[fill="#F1D77A"] {
  fill: #D6AF28;
}
.theme-dark svg path[stroke="#F1D77A"] {
  stroke: #D6AF28;
}
`, "",{"version":3,"sources":["webpack://./src/pos/css/theme-dark.less"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gDAAgD;EAChD,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,gDAAgD;EAChD,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,qBAAqB;EACrB,8CAA8C;EAC9C,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,sBAAsB;EACtB,+CAA+C;EAC/C,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,iCAAiC;EACjC,uBAAuB;EACvB,gDAAgD;EAChD,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,gDAAgD;EAChD,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,oBAAoB;EACpB,6CAA6C;EAC7C,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,yBAAyB;EACzB,gDAAgD;EAChD,kCAAkC;EAClC,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;AACtC;AACA;;;;;;EAME,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;;;;;EAME,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,YAAY;AACd;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,oCAAoC;AACtC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;AACA;;EAEE,+CAA+C;AACjD;AACA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yDAAyD;EACzD,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,yDAAyD;AAC3D;AACA;;;EAGE,cAAc;AAChB;AACA;;;EAGE,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,+BAA+B;AACjC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,4CAA4C;EAC5C,iCAAiC;AACnC;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yDAAyD;EACzD,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yDAA6C;AAC/C;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB","sourcesContent":[".theme-dark {\n  --color-navy-blue: #34495e;\n  --color-navy-blue-fade-5: rgba(52, 73, 94, 0.05);\n  --color-navy-blue-darken-5: #2b3c4e;\n  --color-navy-blue-darken-10: #222f3d;\n  --color-navy-blue-lighten-5: #3d566e;\n  --color-navy-blue-lighten-15: #4f6f8f;\n  --color-navy-blue-lighten-20: #587ca0;\n  --color-navy-blue-lighten-25: #6789ab;\n  --color-navy-blue-lighten-50: #b9c8d8;\n  --color-violet: #D8B1FF;\n  --color-violet-fade-5: rgba(216, 177, 255, 0.05);\n  --color-violet-darken-5: #cb98ff;\n  --color-violet-darken-10: #be7eff;\n  --color-violet-lighten-5: #e5cbff;\n  --color-violet-lighten-15: #fefeff;\n  --color-violet-lighten-20: #ffffff;\n  --color-violet-lighten-25: #ffffff;\n  --color-violet-lighten-50: #ffffff;\n  --color-blue: #b9c8d8;\n  --color-blue-fade-5: rgba(185, 200, 216, 0.05);\n  --color-blue-darken-5: #a9bbcf;\n  --color-blue-darken-10: #98aec6;\n  --color-blue-lighten-5: #c9d5e1;\n  --color-blue-lighten-15: #eaeff3;\n  --color-blue-lighten-20: #fbfbfc;\n  --color-blue-lighten-25: #ffffff;\n  --color-blue-lighten-50: #ffffff;\n  --color-green: #8BE2A3;\n  --color-green-fade-5: rgba(139, 226, 163, 0.05);\n  --color-green-darken-5: #77dd93;\n  --color-green-darken-10: #62d883;\n  --color-green-lighten-5: #9fe7b3;\n  --color-green-lighten-15: #c8f1d4;\n  --color-green-lighten-20: #ddf6e4;\n  --color-green-lighten-25: #f1fbf4;\n  --color-green-lighten-50: #ffffff;\n  --color-yellow: #F1D77A;\n  --color-yellow-fade-5: rgba(241, 215, 122, 0.05);\n  --color-yellow-darken-5: #efd063;\n  --color-yellow-darken-10: #ecc94c;\n  --color-yellow-lighten-5: #f3de91;\n  --color-yellow-lighten-15: #f8ecbf;\n  --color-yellow-lighten-20: #fbf3d6;\n  --color-yellow-lighten-25: #fdfaed;\n  --color-yellow-lighten-50: #ffffff;\n  --color-orange: #FFC38B;\n  --color-orange-fade-5: rgba(255, 195, 139, 0.05);\n  --color-orange-darken-5: #ffb671;\n  --color-orange-darken-10: #ffa958;\n  --color-orange-lighten-5: #ffd0a4;\n  --color-orange-lighten-15: #ffebd8;\n  --color-orange-lighten-20: #fff8f1;\n  --color-orange-lighten-25: #ffffff;\n  --color-orange-lighten-50: #ffffff;\n  --color-red: #FF98A2;\n  --color-red-fade-5: rgba(255, 152, 162, 0.05);\n  --color-red-darken-5: #ff7f8b;\n  --color-red-darken-10: #ff6574;\n  --color-red-lighten-5: #ffb2b9;\n  --color-red-lighten-15: #ffe5e7;\n  --color-red-lighten-20: #fffefe;\n  --color-red-lighten-25: #ffffff;\n  --color-red-lighten-50: #ffffff;\n  --color-red-deep: #c0392b;\n  --color-red-deep-fade-5: rgba(192, 57, 43, 0.05);\n  --color-red-deep-darken-5: #ab3326;\n  --color-red-deep-darken-10: #962d22;\n  --color-red-deep-lighten-5: #d14233;\n  --color-red-deep-lighten-15: #db695d;\n  --color-red-deep-lighten-20: #df7c72;\n  --color-red-deep-lighten-25: #e48f86;\n  --color-red-deep-lighten-50: #fbf0ef;\n}\n.theme-dark .screen,\n.theme-dark .header,\n.theme-dark .footer,\n.theme-dark .modal-content,\n.theme-dark .btn-action-grid,\n.theme-dark .legacy-styles {\n  background: #2e3440;\n  color: #eceff4;\n  border-color: #4c566a;\n}\n.theme-dark .screen .waiting-overlay,\n.theme-dark .header .waiting-overlay,\n.theme-dark .footer .waiting-overlay,\n.theme-dark .modal-content .waiting-overlay,\n.theme-dark .btn-action-grid .waiting-overlay,\n.theme-dark .legacy-styles .waiting-overlay {\n  background: #2e3440;\n}\n.theme-dark .header ul,\n.theme-dark .header li {\n  background: #4c566a;\n  color: #eceff4;\n}\n.theme-dark h1 small {\n  color: #e5e9f0;\n}\n.theme-dark .modal-header,\n.theme-dark .modal-footer {\n  background: #4c566a;\n  color: #eceff4;\n  border-color: #4c566a;\n}\n.theme-dark .modal-header button.close,\n.theme-dark .modal-footer button.close {\n  color: #eceff4;\n  opacity: 0.8;\n}\n.theme-dark .modal-header .btn-default,\n.theme-dark .modal-footer .btn-default {\n  border-color: #eceff4;\n}\n.theme-dark .border-bottom {\n  border-color: #4c566a;\n}\n.theme-dark .modal-backdrop {\n  opacity: 0.75;\n}\n.theme-dark .btn-action-grid-container .modal-backdrop {\n  background: rgba(0, 0, 0, 0.75);\n}\n.theme-dark .btn-default {\n  background: #4c566a;\n  color: #eceff4;\n  border-color: #4c566a;\n}\n.theme-dark .btn-default:active,\n.theme-dark .btn-default:hover:active {\n  color: #eceff4;\n  border-color: #4c566a;\n  background: #2e3440;\n}\n.theme-dark .btn-default.selected {\n  border: 2px solid var(--color-green);\n}\n.theme-dark .btn-primary.btn-outline {\n  color: #eceff4;\n}\n.theme-dark .btn-primary.btn-outline:active {\n  background: rgba(255, 255, 255, 0.4);\n}\n.theme-dark .btn-info {\n  background: var(--color-blue);\n  border-color: var(--color-blue);\n  color: #eceff4;\n}\n.theme-dark .btn-info.btn-outline {\n  background: transparent;\n  color: white;\n}\n.theme-dark .btn-info.btn-outline:active {\n  background: rgba(255, 255, 255, 0.4);\n}\n.theme-dark .btn-value:active,\n.theme-dark .btn-value:hover:active {\n  border-color: var(--color-green);\n}\n.theme-dark .btn-value img[src] + span {\n  background: rgba(0, 0, 0, 0.6);\n}\n.theme-dark .btn-value .btn-value-badge {\n  background: #4c566a;\n  border: 1px solid #4c566a;\n  color: #eceff4;\n}\n.theme-dark .bg-value-button-grid-separator {\n  background-color: #4c566a;\n}\n.theme-dark.theme-show-help .btn-action img + span,\n.theme-dark.theme-show-help .btn-action svg + span {\n  background: rgba(0, 0, 0, 0.6);\n}\n.theme-dark.theme-show-help .btn-action img + span span,\n.theme-dark.theme-show-help .btn-action svg + span span {\n  color: #eceff4;\n}\n.theme-dark .form-control::placeholder {\n  color: #647ca5;\n}\n.theme-dark .form-control,\n.theme-dark .form-control[readOnly]:not(.disable-keypad) {\n  cursor: default;\n  background-color: #2e3440;\n  border-color: #4c566a !important;\n  color: #eceff4;\n}\n.theme-dark .form-control[readOnly]:not(.disable-keypad).selected,\n.theme-dark .form-control:focus {\n  border: 1px solid var(--color-green) !important;\n}\n.theme-dark .input-group-addon {\n  border-color: #4c566a !important;\n  background-color: #2e3440;\n  color: #eceff4;\n}\n.theme-dark .has-error .help-block {\n  font-weight: 600;\n  color: #BF616A;\n}\n.theme-dark ul.list li:nth-child(even) {\n  background: #3e4552;\n}\n.theme-dark ul.list li.selected {\n  background-color: var(--color-green-lighten-5) !important;\n  color: #2e3440 !important;\n}\n.theme-dark ul.list li.selected .btn-info {\n  border-color: #2e3440;\n}\n.theme-dark .table-striped > tbody > tr:nth-of-type(odd) {\n  background-color: #4c566a;\n}\n.theme-dark .select2-container .select2-selection,\n.theme-dark .select2-container .select2-results,\n.theme-dark .select2-container .select2-search--dropdown {\n  background: #2e3440;\n  border-color: #4c566a;\n}\n.theme-dark .select2-container .select2-selection span,\n.theme-dark .select2-container .select2-results span,\n.theme-dark .select2-container .select2-search--dropdown span {\n  color: #eceff4;\n}\n.theme-dark .select2-container .select2-selection b,\n.theme-dark .select2-container .select2-results b,\n.theme-dark .select2-container .select2-search--dropdown b {\n  border-color: #eceff4 transparent transparent transparent;\n}\n.theme-dark .select2-container .select2-selection li,\n.theme-dark .select2-container .select2-results li,\n.theme-dark .select2-container .select2-search--dropdown li {\n  color: #e5e9f0;\n}\n.theme-dark .select2-container .select2-selection input,\n.theme-dark .select2-container .select2-results input,\n.theme-dark .select2-container .select2-search--dropdown input {\n  cursor: default;\n  background-color: #2e3440;\n  border-color: #4c566a !important;\n  color: #eceff4;\n}\n.theme-dark .select2-container .select2-dropdown {\n  border-color: #4c566a;\n}\n.theme-dark .select2-container .select2-results__option[aria-selected=true] {\n  background: #4c566a;\n  color: #eceff4;\n}\n.theme-dark .abc-checkbox label::before {\n  background-color: #2e3440;\n  border-color: #4c566a;\n}\n.theme-dark .abc-checkbox label::after {\n  color: #eceff4;\n}\n.theme-dark .react-datepicker {\n  background: #2e3440;\n  border-color: #4c566a;\n}\n.theme-dark .react-datepicker .react-datepicker__header,\n.theme-dark .react-datepicker .react-datepicker__today-button {\n  background: #4c566a;\n  border-color: #4c566a;\n  color: var(--color-blue);\n}\n.theme-dark .react-datepicker .react-datepicker__day-name,\n.theme-dark .react-datepicker .react-datepicker__day,\n.theme-dark .react-datepicker .react-datepicker__time-name,\n.theme-dark .react-datepicker .react-datepicker__current-month,\n.theme-dark .react-datepicker .react-datepicker-time__header,\n.theme-dark .react-datepicker .react-datepicker-year-header {\n  color: #eceff4;\n}\n.theme-dark .react-datepicker .react-datepicker__day--outside-month {\n  color: #4c566a;\n}\n.theme-dark .react-datepicker .react-datepicker__day--outside-month:hover {\n  color: #eceff4;\n}\n.theme-dark .react-datepicker .react-datepicker__day:hover,\n.theme-dark .react-datepicker .react-datepicker__month-text:hover,\n.theme-dark .react-datepicker .react-datepicker__quarter-text:hover,\n.theme-dark .react-datepicker .react-datepicker__today-button:hover {\n  background-color: #4c566a;\n}\n.theme-dark .alert-warning {\n  color: #8a6d3b;\n  background-color: #ebcb8b;\n  border-color: #ebcb8b;\n}\n.theme-dark .text-muted {\n  color: #a4b2cb !important;\n}\n.theme-dark .text-danger {\n  color: #BF616A !important;\n}\n.theme-dark .text-info {\n  color: white !important;\n}\n.theme-dark .text-info.fa-chevron-down,\n.theme-dark .text-info.fa-chevron-up {\n  color: white !important;\n}\n.theme-dark #toast-container > div {\n  background: #4c566a !important;\n  background-image: none !important;\n}\n.theme-dark #toast-container > div .btn-default {\n  border-color: #eceff4;\n}\n.theme-dark #toast-container > div .toast-message {\n  background: #4c566a;\n  color: #eceff4;\n}\n.theme-dark .keypad-container-wrapper {\n  background-color: #2e3440;\n}\n.theme-dark .keypad {\n  background-color: #2e3440;\n}\n.theme-dark .keyboard-container {\n  background-color: #2e3440;\n  border-top: 1px solid #4c566a;\n}\n.theme-dark .ticket-lines-total {\n  border-top: 1px solid #4c566a;\n  background: #2e3440;\n}\n.theme-dark .panel-horizontal {\n  background: #2e3440;\n  border-top-color: #2e3440;\n  border-right-color: #2e3440;\n  border-bottom-color: #2e3440;\n}\n.theme-dark .panel-horizontal.info {\n  border-left-color: var(--color-blue);\n}\n.theme-dark .panel-horizontal.info.selected {\n  background-color: var(--color-blue-fade-5);\n  border-color: var(--color-blue);\n}\n.theme-dark .panel-horizontal.success {\n  border-left-color: var(--color-green);\n}\n.theme-dark .panel-horizontal.success.selected {\n  background-color: var(--color-green-fade-5);\n  border-color: var(--color-green);\n}\n.theme-dark .panel-horizontal.primary {\n  border-left-color: var(--color-navy-blue);\n}\n.theme-dark .panel-horizontal.primary.selected {\n  background-color: var(--color-navy-blue-fade-5);\n  border-color: var(--color-navy-blue);\n}\n.theme-dark .panel-horizontal.primary2 {\n  border-left-color: var(--color-violet);\n}\n.theme-dark .panel-horizontal.primary2.selected {\n  background-color: var(--color-violet-fade-5);\n  border-color: var(--color-violet);\n}\n.theme-dark .panel-horizontal.warning {\n  border-left-color: var(--color-yellow);\n}\n.theme-dark .panel-horizontal.warning.selected {\n  background-color: var(--color-yellow-fade-5);\n  border-color: var(--color-yellow);\n}\n.theme-dark .panel-horizontal.warning2 {\n  border-left-color: var(--color-orange);\n}\n.theme-dark .panel-horizontal.warning2.selected {\n  background-color: var(--color-orange-fade-5);\n  border-color: var(--color-orange);\n}\n.theme-dark .panel-horizontal.danger {\n  border-left-color: var(--color-red-deep);\n}\n.theme-dark .panel-horizontal.danger.selected {\n  background-color: var(--color-red-deep-fade-5);\n  border-color: var(--color-red-deep);\n}\n.theme-dark .panel-horizontal.danger2 {\n  border-left-color: var(--color-red);\n}\n.theme-dark .panel-horizontal.danger2.selected {\n  background-color: var(--color-red-fade-5);\n  border-color: var(--color-red);\n}\n.theme-dark .bg-light {\n  background: #3e4552;\n}\n.theme-dark .border-top {\n  border-top: 1px solid #4c566a;\n}\n.theme-dark .border-bottom {\n  border-bottom: 1px solid #4c566a;\n}\n.theme-dark .border-right {\n  border-right: 1px solid #4c566a;\n}\n.theme-dark .border-left {\n  border-left: 1px solid #4c566a;\n}\n.theme-dark .card-grid .card {\n  border-color: #4c566a;\n}\n.theme-dark .card-grid .card:hover {\n  border-color: #616e88;\n}\n.theme-dark .card-grid .card.selected {\n  border-color: var(--color-green);\n}\n.theme-dark .card-grid .card .card-title {\n  color: #eceff4;\n}\n.theme-dark .card-grid .card .card-description {\n  color: #e5e9f0;\n}\n.theme-dark ul.dropdown-menu {\n  background-color: #4c566a;\n}\n.theme-dark ul.dropdown-menu li:hover,\n.theme-dark ul.dropdown-menu li:active {\n  background: #2e3440;\n}\n.theme-dark .public_fixedDataTable_main {\n  background: #2e3440;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_header .public_fixedDataTableCell_main {\n  background: #4c566a;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_header .public_fixedDataTableCell_cellContent {\n  color: #eceff4 !important;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main {\n  background: #2e3440;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main .public_fixedDataTableCell_main {\n  background: #2e3440;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main.public_fixedDataTableRow_odd {\n  background: #3e4552;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTableRow_main.public_fixedDataTableRow_odd .public_fixedDataTableCell_main {\n  background: #3e4552;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer {\n  border-color: #4c566a;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer .public_fixedDataTableCell_main {\n  background: #4c566a;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_footer .public_fixedDataTableCell_cellContent {\n  color: #eceff4 !important;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTable_hasBottomBorder {\n  border-color: #4c566a;\n}\n.theme-dark .public_fixedDataTable_main .public_fixedDataTableCell_main {\n  border-right: 0px solid transparent;\n}\n.theme-dark .public_fixedDataTable_main .selected .public_fixedDataTableCell_main {\n  background-color: var(--color-green-lighten-5) !important;\n  color: #2e3440 !important;\n}\n.theme-dark .public_fixedDataTable_main .public_Scrollbar_main {\n  background-color: #2e3440;\n}\n.theme-dark .public_fixedDataTable_main .public_Scrollbar_face:after {\n  background-color: #4c566a;\n}\n.theme-dark .public_fixedDataTable_main > .tools-buttons .btn-outline.btn-info {\n  background-color: #2e3440;\n}\n.theme-dark .numeric-datatable.public_fixedDataTable_main .public_fixedDataTable_bodyRow .public_fixedDataTableCell_cellContent {\n  background: #4c566a;\n}\n.theme-dark .numeric-datatable.public_fixedDataTable_main .public_fixedDataTable_bodyRow .numeric .public_fixedDataTableCell_cellContent {\n  background: #2e3440;\n}\n.theme-dark .bg-logo {\n  background-image: url('../img/logo-dark.png');\n}\n.theme-dark .simple-keyboard {\n  background-color: #2e3440;\n  border-color: #4c566a;\n}\n.theme-dark .simple-keyboard .hg-button {\n  background: #4c566a;\n  color: #f7f9fa;\n  border-color: #4c566a;\n}\n.theme-dark .simple-keyboard .hg-button:active {\n  background: #2e3440;\n  border-color: #4c566a;\n}\n.theme-dark .simple-keyboard .hg-button.hg-button-special {\n  color: #f7f9fa;\n  border-color: #4c566a;\n  background-color: var(--color-navy-blue);\n}\n.theme-dark svg path[fill=\"#4C566A\"] {\n  fill: white;\n}\n.theme-dark svg path[stroke=\"#4C566A\"] {\n  stroke: white;\n}\n.theme-dark svg path[fill=\"#61AAED\"] {\n  fill: #A6D4FF;\n}\n.theme-dark svg path[stroke=\"#61AAED\"] {\n  stroke: #A6D4FF;\n}\n.theme-dark svg path[fill=\"#C291F3\"] {\n  fill: #D8B1FF;\n}\n.theme-dark svg path[stroke=\"#C291F3\"] {\n  stroke: #D8B1FF;\n}\n.theme-dark svg path[fill=\"#FFBA7B\"] {\n  fill: #FFC38B;\n}\n.theme-dark svg path[stroke=\"#FFBA7B\"] {\n  stroke: #FFC38B;\n}\n.theme-dark svg path[fill=\"#A2BAD0\"] {\n  fill: #ACC0D2;\n}\n.theme-dark svg path[stroke=\"#A2BAD0\"] {\n  stroke: #ACC0D2;\n}\n.theme-dark svg path[fill=\"#FF8A95\"] {\n  fill: #FF98A2;\n}\n.theme-dark svg path[stroke=\"#FF8A95\"] {\n  stroke: #FF98A2;\n}\n.theme-dark svg path[fill=\"#75CA8D\"] {\n  fill: #8BE2A3;\n}\n.theme-dark svg path[stroke=\"#75CA8D\"] {\n  stroke: #8BE2A3;\n}\n.theme-dark svg path[fill=\"#D6AF28\"] {\n  fill: #F1D77A;\n}\n.theme-dark svg path[stroke=\"#D6AF28\"] {\n  stroke: #F1D77A;\n}\n.theme-dark svg path[fill=\"white\"] {\n  fill: #4C566A;\n}\n.theme-dark svg path[stroke=\"white\"] {\n  stroke: #4C566A;\n}\n.theme-dark svg path[fill=\"#A6D4FF\"] {\n  fill: #61AAED;\n}\n.theme-dark svg path[stroke=\"#A6D4FF\"] {\n  stroke: #61AAED;\n}\n.theme-dark svg path[fill=\"#D8B1FF\"] {\n  fill: #C291F3;\n}\n.theme-dark svg path[stroke=\"#D8B1FF\"] {\n  stroke: #C291F3;\n}\n.theme-dark svg path[fill=\"#FFC38B\"] {\n  fill: #FFBA7B;\n}\n.theme-dark svg path[stroke=\"#FFC38B\"] {\n  stroke: #FFBA7B;\n}\n.theme-dark svg path[fill=\"#ACC0D2\"] {\n  fill: #A2BAD0;\n}\n.theme-dark svg path[stroke=\"#ACC0D2\"] {\n  stroke: #A2BAD0;\n}\n.theme-dark svg path[fill=\"#FF98A2\"] {\n  fill: #FF8A95;\n}\n.theme-dark svg path[stroke=\"#FF98A2\"] {\n  stroke: #FF8A95;\n}\n.theme-dark svg path[fill=\"#8BE2A3\"] {\n  fill: #75CA8D;\n}\n.theme-dark svg path[stroke=\"#8BE2A3\"] {\n  stroke: #75CA8D;\n}\n.theme-dark svg path[fill=\"#F1D77A\"] {\n  fill: #D6AF28;\n}\n.theme-dark svg path[stroke=\"#F1D77A\"] {\n  stroke: #D6AF28;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
